export const en = {
  news: 'news',
  news_table: 'news table',
  breaking: 'breaking',
  unnecessary: 'unnecessary',
  trashed: 'trashed',
  posts: 'posts',
  source: 'source',
  author_editor: 'author / editor',
  grabbed_on: 'grabbed on',
  category: 'category',
  country: 'country',
  has_video: 'has video',
  author: 'author',
  search_by_posts: 'search by posts',
  breaking_on: 'breaking on',
  added_on: 'added on',
  trashed_on: 'trashed on',
  new_source_edition: 'add new edition source',
  new_source: 'add new source',
  edit_source_edition: 'edit edition source',
  edit_source: 'edit source',
  source_information: 'source information',
  additional_information: 'additional information',
  grabbing_information: 'grabbing information',
  select_grabbing_method: 'select grabbing method',
  grabbing_data: 'grabbing data',
  assign_categories: 'assign categories',
  done: 'done',
  total_posts: 'total posts',
  total_sources: 'total sources',
  total_authors: 'total authors',
  created_categories: 'created categories',
  tags: 'tags',
  posts_categories: 'articles /category',
  posts: 'posts',
  source_status: 'source status',
  source_status_edition: 'source edition status',
  top_used_tags: 'top used tags',
  breaking_news: 'breaking news',
  top_authors: 'top authors',
  top_editors: 'top editors',
  numOfNewsGrabbed: 'number of articles grabbed',
  author_tables: 'authors table',
  editor_tables: 'editors table',
  articles: 'articles',
  articles_number: 'Articles Number',
  sources: 'sources',
  author: 'author',
  types_of_categories: 'types of categories',
  related_names: 'related names',
  source_name: 'source name',
  source_url: 'source url',
  source_priority: 'source Priority',
  grab_data_from: 'grab data from date',
  graping_start_date: 'grab data from date',
  grab_data_to: 'grab data to date',
  regrabbing_period: 're-grabbing period',
  grabbing_data_desc:
    'We are collecting data. You will see collected data in 5-15 minutes.Please wait…',
  grabbing_data_err_desc:
    'We are unable to grab news from provided source URL either by automatic grabbing',
  html_hint: 'You must have intermediate HTML knowledge to continue',
  start_manual_grabbing: 'Start Manual Grabbing',
  linkage: 'link to tag',
  ch_to_m_grabbing: 'change to manual grabbing',
  ch_to_a_grabbing: 'Change To Automatic Grabbing',
  tags: 'tags',
  tags_table: 'tags table',
  search_by_tags: 'search by tags',
  grabbed_by: 'grabbed by',
  author_details: 'author details',
  editor_details: 'editor details',
  total_num_of_articles: 'total number of articles',
  publish_date: 'publish date',
  news_title: 'news title',
  publish_source: 'publish source',
  publish_source_edition: 'publish source edition',
  description: 'Description',
  first_grabbed_from: 'First grabbed from ',
  author_information: 'author information',
  editor_information: 'editor information',
  age: 'Age',
  language: 'Language',
  type_of_category: 'type of category',
  author_name: 'author name',
  date_of_birth: 'date of birth',
  note_desc:
    'please noted that any name you will add will appear as the author name',
  note_desc_editor:
    'please noted that any name you will add will appear as the editor name',
  enter_author_name: 'enter author name',
  enter_editor_name: 'enter editor name',
  Note: 'Note',
  manual_grabbing: 'manual grabbing',
  automatic_grabbing: 'automatic grabbing',
  automatic_grabbing_desc:
    'user selects automatic grabbing the system will automatically try to identify the location of the (menu, news list, news details page).',
  rss_desc:
    'user selects RSS, grabbing the system will automatically try to identify the location of the (RSS) technology location in the website',
  manual_desc:
    'user can add news sources by through manual grabbing Identifying the menu location by identifying the (menu, news list) (class or element and its anchor tag) and finally by identifying (class or element and its anchor tag) for news (image, title, editor, details paragraph, tags).',
  rss: 'rss',
  bounce_rate: 'Bounce Rate',
  search_traffic: 'Search Traffic',
  rank: 'Rank',
  page_per_visit: 'Page per Visit',
  daily_time_on_site: 'Daily Time on Site',
  monthly_traffic: 'Monthly Traffic',
  author_articles: 'Author Articles',
  author_article: 'Author Articles',
  related_tags: 'Related Tags',
  related_posts: 'Related Posts',
  edit_author_details: 'edit author details',
  edit_editor_details: 'edit editor details',
  change_picture: 'change picture',
  cancel_edit_author_message:
    'Are you sure you want to cancel editing author details ?',
  cancel_edit_editor_message:
    'Are you sure you want to cancel editing editor details ?',
  addcategory_cancel_message:
    'Are you sure you want to cancel adding category?',
  add_new_category: 'add new category',
  category_information: 'category information',
  category_name: 'category name',
  parent_category: 'parent category',
  slug: 'slug',
  collect_sections: 'Collect sections (Menu)',
  source_page: 'Source Page URL ',
  nearest_attr:
    'find the nearest attribute and class for the anchor tag that carry the section url',

  pagination_attr: 'Find pagination selector',
  tags: 'tags',
  selectors: 'selectors',
  grabbed_categories: 'Sample of grabbed Categories',
  grabbed_list: 'Sample of grabbed List',
  title: 'title',
  url: 'URL',
  news_category: 'news category',
  news_categories: 'news categories',
  number_of_posts: 'number of posts',
  articles_details: 'Articles Details',
  find_news_img: 'Find News Image',
  find_news_title: 'Find News title',
  find_news_editor: 'Find News editor',
  find_news_details: 'Find News details',
  find_news_tags: 'Find News tags',
  find_news_date: 'find news date',
  sources_table: 'sources table',
  source_details: 'source details',
  news_grabbed: 'news grabbed',
  system_category: 'system category',
  main_section: 'main section',
  method: 'method',
  created_on: 'created on',
  grabbed_from: 'grabbed from',
  grabbed_to: 'grabbed to',
  language: 'language',
  priority: 'priority',
  categories: 'Categories',
  sections_retrieved: 'Sections Retrieved',
  assign_category: 'assign category',
  note: 'Please noted',
  note_description:
    "that If you don't assign any category will be moved to uncategorized category",
  grab_to_present: 'Grab Data To Present',
  all_categories_found: 'all categories found',
  edit: 'Edit Garbing Method',
  world_news: 'world news',
  grabbed_news_list: 'grabbed news list',
  grabbed_article_details: 'grabbed article details',
  title: 'title',
  editor: 'editor',
  grapped_image: 'grapped image',
  details: 'details',
  new_tags: 'new tags',
  search_by_source: 'search by source',
  num_of_grabbed_posts: 'no. of grabbed posts',
  num_of_source_editions: 'No. of Source editions',
  status: 'status',
  logs: 'logs',
  active: 'active',
  paused: 'paused',
  paused_source: 'paused',
  active_source: 'active',
  search_by_author: 'search by author',
  search_by_editor: 'search by editor',
  article_url: 'article url',
  tag: 'tag',
  newss: 'news',
  grabbing_period_hours: 'every {{time}} hours',
  grabbing_period_hour: 'every {{time}} hour',
  every_1_hour: 'Every 1 Hour',
  news_details: 'news details',
  cant_link: ' one of the selected is linked before',
  languages_is_required: 'languages is required',
  year: 'Year',
  posts_title: 'posts title',
  remove_linkage: 'remove linkage',
  present: 'present',
  failed_grab: 'Failed to grab data, please check the selectors',
  main_name: 'Please select the main name',
  linked_tags: 'linked tags',
  collecting_data: 'We are collecting data',
  By: 'By ',
  yes: 'Yes',
  no: 'No',
  no_posts: 'no related posts is found',
  every: 'Every',
  hours: 'Hours',
  Language: 'Language',
  date: 'date',
  dead: 'dead',
  issue: 'issue',
  date_of_birth: 'date of birth',
  languages: 'languages',
  editcategory_cancel_message:
    'Are you sure you want to cancel editing category?',
  total_articles: 'total articles',
  created_by: 'created by',
  articles_count: 'articles count',
  analyzed_category: 'ANALYZED CATEGORY TO NEWS',
  media: 'media',
  MANUAL: 'MANUAL',
  RSS: 'RSS',
  AUTOMATIC: 'AUTOMATIC',
  added_media: 'Added media',
  parent_attached: 'Parent attached successfully',
  source_edit_success: 'source edit successfully, Go To ',
  source_added_success: 'source added successfully, Go To ',
  tags_articles: 'tags articles',
  article_tags: 'article tags',
  errorSourceInformation: 'this source already exists',
  samplesCategories: 'Health News, Economy News, CoronaVirus News',
  AR: 'AR',
  EN: 'EN',
  source_language: 'Source Edition Language',
  incompleted: 'incompleted',
  direction: 'Direction',
  parent_source: 'Parent Source',
  grabbing: 'grabbing',
  select_group: 'Please select the Group',
  existing_group: 'Existing Group',
  new_group: 'New Group',
  grabbing_pagination: 'grabbing > {{step}} > {{name}}',
  sections: 'Sections',
  total_source_editions: 'Total Source Editions',
  total_editors: 'Total editors',
  opinion_articles: 'Opinion articles',
  source_edition: 'source edition ',
  source_edition_table: 'source edition table',
  source_editions_table: 'source editions table',
  no_articles: 'No. of Articles',
  editor_name: 'editor name',
  no_grabbed_news: 'No. of grabbed News',
  location: 'location',
  opinion_articles_grabbed: 'Opinion articles grabbed',
  editors: 'editors',
  editor: 'editor',
  source_editions_details: 'source editions details',
  total_sources_editions: 'Total Sources Editions',
  you_can_skip: 'You can skip the automatic detecting',
  source_edition_status: 'Sources edition status',
  skip: 'skip',
  variant: 'variant',
  add_variant: 'Add Another Variant',
  delete_variant: 'Delete Grabbed Variant',
  are_you_sure_you_want_to_delete_variant:
    'Are you sure you want to permanently delete this variant ?',
  editions: 'editions',
  source_editions: 'source editions ',
  directions: 'directions',
  authors: 'authors',
  key: 'key',
  value: 'value',
  from: '/',
  err_title_required: 'Please enter a valid title selector',
  err_source_required: 'please grabbing data',
  date_format: 'Date format',
  choose_date_format: 'choose date format',
  edit_grabbing_data: 'Edit grabbing data',
  addauthor: 'add author as an influncer',
  addnewinfluncerasauthor:
    'Is this author is based on an already existing infulencer ?!',
  alreadyexists: 'Add Author based on an existing Influncer',
  newauthorinflncer: 'Add This Author as a new Influncer',
  authorandinfluncer: 'both an influncer and an author',
  selectinf: 'please select the existing influncer',
  searchinf: 'search analyzed influncers',
  news_article: 'News Article',
  total_sources: 'Total Sources',
  articles_per_month: 'Articles per month',
  author_sorce: 'AUTHORS SOURCE',
  frequently_used_tags: 'FREQUENTLY USED TAGS',
  top_frequent_tags: 'TOP FREQUENT TAGS',
  top_categories: 'Top Categories',
  article_calander: 'ARTICLES CALANDER',
  tags_used: 'Tags Used',
  search_articles: 'Search Articles',
  article_archive: 'Article Archive',
  Select_Excluding_Type: 'Select Excluding Type',
  excluding_type: 'Excluding Type',
  regular_expression: 'Regular Expression',
  selector: 'Selector',
  clone: 'clone',
  reset: 'reset',
  Find_the_CSS_selector_element:
    'Find the CSS selector of an element that carry the section URL *',

  Find_the_CSS_selector_pagination:
    'Find the CSS selector for  pagination selector ',
  invalid_selector: 'invalid selector',
  variants_number: `Variants number mustn't exceed four variants`,
  pagination_selector_type: 'pagination selector type',
  select_pagination_selector_type: 'select pagination selector type',
  pagination_pages: 'pagination pages',
  load_more_button: 'load more button',
  auto_scroll: 'auto scroll',
  ungrabbed_articles: 'ungrabbed articles',
  search_by_article: 'search by article',
  no_pagination: 'no pagination',
  source_edition_exists: 'This source edition exists in the system before',
  complete_adding: 'to complete adding the source edition',
  click_here: 'click here',
  search_by_url: 'search by url',
  error: 'error',
};

export const ar = {
  error: 'الخطأ',
  search_by_url: 'ابحث بالرابط',
  complete_adding: 'لإكمال إضافة اصدار المصدر',
  click_here: 'اضغط هنا ',
  source_edition_exists: ' اصدار المصدر تم اضافته من قبل ',
  search_by_article: '  بحث بإسم المقال',
  ungrabbed_articles: 'المقالات الغير مُحلله',
  no_pagination: 'بدون ترقيم الصفحات',
  pagination_pages: 'صفحات ترقيم الصفحات',
  load_more_button: 'زر تحميل المزيد',
  auto_scroll: 'التمرير التلقائي',
  select_pagination_selector_type: 'حدد نوع محدد ترقيم الصفحات',
  pagination_selector_type: 'نوع محدد ترقيم الصفحات',
  variants_number: 'لا يمكن إضافة أكثر من أربعة متغيرات',
  invalid_selector: 'المُحدد غير صحيح',
  Find_the_CSS_selector_pagination: 'ابحث عن محدد CSS لمحدد ترقيم الصفحات ',

  Find_the_CSS_selector_element:
    'ابحث عن محدد CSS لعنصر يحمل عنوان رابط للقسم *',
  reset: 'إعادة تعيين',
  clone: 'استنساخ',
  regular_expression: 'Regular Expression',
  selector: 'Selector',
  excluding_type: 'نوع الاستبعاد',
  Select_Excluding_Type: 'حدد نوع الاستبعاد',
  news_article: 'المقالات الاخباريه',
  search_articles: 'البحث في المقلات',
  article_calander: 'المواعيد الزمنيه للمقالات',
  tags_used: 'الوسوم المستخدمه',
  author_sorce: 'مصادر كاتب الرأي',
  frequently_used_tags: 'الوسوم المستخدمه باستمرار',
  top_frequent_tags: 'الوسوم الاكثر تكراراً',
  top_categories: 'الفئات الأكثر تكراراً',
  total_sources: 'جميع المصادر',
  articles_per_month: 'المقلات في الشهر',
  incompleted: 'غير مكتمل',
  source_language: 'لغه اصدار المصدر',
  AR: 'العربيه',
  EN: 'English',
  article_tags: 'وسوم المقال',
  tags_articles: 'مقالات الوسوم',
  article_archive: 'تاريخ المقالات',
  source_edit_success: ' تم تعديل المصدر بنجاح , إذهب إلى ',
  source_added_success: ' تم إضافة المصدر بنجاح, إذهب إلى ',

  parent_attached: 'تم إرفاق الفئه الأساسية بنجاح',
  RSS: 'RSS',
  AUTOMATIC: 'تلقائي',
  MANUAL: 'يدوي',
  media: 'الوسائل المتعدده',
  analyzed_category: 'الفئه المحلله للاخبار ',
  articles_count: 'عدد المقالات',
  created_by: 'تم الإنشاء بواسطة',
  total_articles: 'إجمالي المقالات',
  editcategory_cancel_message: 'هل أنت متأكد أنك تريد إلغاء تعديل الفئة؟',
  languages: 'اللغات',
  date_of_birth: 'تاريخ الميلاد',
  dead: 'ميت',
  issue: 'لديه خطأ',
  date: 'التاريخ',
  Language: 'اللغه',
  every: 'كل',
  hours: 'ساعه',
  author_details_edited_success: 'تم تحرير تفاصيل كاتب رأي بنجاح',
  no_posts: 'لم يتم العثور على منشورات ذات صلة',
  yes: 'نعم',
  no: 'لا',
  By: 'بواسطة   ',
  linked_tags: 'الوسوم المتصلة',
  main_name: 'الرجاء تحديد الاسم الرئيسي',
  present: 'حتي الان',
  remove_linkage: 'حذف الربط',
  cant_link: ' واحد من العناصر المحدده مرتبط من قبل',
  posts_title: 'عنوان المنشور',
  year: 'سنه',
  languages_is_required: 'هذا الحقل مطلوب',
  news_details: 'تفاصيل الخبر',
  newss: 'الخبر',
  news: 'الاخبار',
  tag: 'الوسم',
  search_by_author: 'بحث بإسم كاتب رأي',
  search_by_editor: 'بحث بإسم المحرر',
  active: 'تفعيل',
  paused: 'ايقاف',
  paused_source: 'متوقف',
  active_source: 'مفعل',
  search_by_source: 'بحث بواسطة المصدر',
  num_of_grabbed_posts: 'عدد المشاركات التي تم جلبها',
  num_of_source_editions: 'عدد إصدارات المصدر',
  status: 'الحالة',
  logs: 'السجلات',
  all_categories_found: 'جميع الفئات التي تم العثور عليها',
  edit: 'تعديل طريقة الجلب',
  world_news: 'اخبار العالم',
  grabbed_news_list: 'جلب قائمة الاخبار',
  grabbed_article_details: 'جلب تفاصيل المقال',
  title: 'العنوان',
  editor: 'المحرر',
  articles_number: 'عدد المقالات',
  grapped_image: 'جلب الصورة',
  details: 'التفاصيل',
  new_tags: 'الوسوم الجديده',
  language: 'اللغه',
  priority: 'الأولويه',
  sources_table: 'جدول المصادر',
  source_details: 'تفاصيل المصدر',
  news_grabbed: 'جلب الاخبار',
  system_category: 'فئه المصدر',
  main_section: 'القسم الأساسي',
  method: 'الطريقه',
  created_on: 'تم الإنشاء في',
  grabbed_from: 'جُلب من',
  grabbed_to: 'جُلب ل',
  add_new_category: 'إضافة فئه جديده',
  category_information: 'معلومات الفئه',
  category_name: 'اسم الفئه',
  parent_category: 'القسم الرئيسي',
  slug: 'اسم المفتاح',
  addcategory_cancel_message: 'هل انت متاكد انك تريد الغاء إضافة الفئه؟',
  change_picture: 'تغير الصورة',
  edit_author_details: 'تعديل تفاصيل كاتب رأي',
  edit_editor_details: 'تعديل تفاصيل المحرر',
  bounce_rate: 'معدل الإرتداد',
  search_traffic: 'إشارة البحث',
  rank: 'مكانه',
  page_per_visit: 'صفحة لكل زيارة',
  daily_time_on_site: 'الوقت اليومي في الموقع',
  monthly_traffic: 'الإشارة الشهرية',
  author_articles: 'مقالات كاتب الرأي',
  author_article: 'مقالات كاتب',
  related_tags: 'الوسوم ذات صلة',
  related_posts: 'المنشورات ذات صلة',
  Note: 'ملاحظه',
  author_name: 'اسم كاتب الرأي',
  enter_author_name: 'ادخل اسم كاتب الرأي',
  enter_editor_name: 'ادخل اسم المحرر',
  note_desc: 'يرجى ملاحظة أن أي اسم ستضيفه سيظهر كأسم كاتب رأي',
  note_desc_editor: 'يرجى ملاحظة أن أي اسم ستضيفه سيظهر كأسم محرر',
  author_details: 'تفاصيل كاتب الرأي',
  editor_details: 'تفاصيل المحرر',
  total_num_of_articles: 'العدد الإجمالي للمقالات',
  publish_date: 'تاريخ النشر',
  news_title: 'عنوان الخبر',
  publish_source: ' مصدر النشر',
  publish_source_edition: ' مصدر النشر',
  description: 'الوصف',
  first_grabbed_from: 'تم الجلب للمره الاولي من  ',
  author_information: 'معلومات كاتب الرأي',
  editor_information: 'معلومات المحرر',
  age: 'العٌمر',
  language: 'اللغه',
  type_of_category: 'نوع الفئه',
  tags: 'الوسوم',
  tags_table: 'جدول الوسوم',
  search_by_tags: 'بحث بالوسم',
  grabbed_by: 'تم الجلب بواسطة ',
  linkage: 'رابط للوسم',
  news: 'الأخبار',
  news_table: 'جدول الأخبار',
  breaking: 'عاجل',
  unnecessary: 'غير مهم',
  trashed: 'محذوف',
  posts: 'المنشورات',
  source: 'المصدر',
  author_editor: 'كاتب الرأي / المحرر',
  grabbed_on: 'تم الإحضار في',
  category: 'الفئة',
  country: 'الدولة',
  has_video: 'يحتوي علي فيديو',
  author: 'كاتب رأي',
  search_by_posts: 'بحث بالمنشورات',
  breaking_on: 'عاجل في',
  added_on: 'تمت الإضافة في',
  trashed_on: 'تم الحذف في',
  new_source_edition: 'إضافة نسخة مصدر جديد',
  new_source: 'إضافة مصدر جديد',
  edit_source_edition: 'تعديل نسخه المصدر',
  edit_source: 'تعديل المصدر',
  source_information: 'معلومات المصدر',
  grabbing_information: 'معلومات الجلب',
  select_grabbing_method: 'اختر وسيلة الجلب',
  grabbing_data: 'بيانات الجلب',
  edit_grabbing_data: 'تعديل بيانات الجلب',
  assign_categories: 'إسناد الفئات',
  done: 'تم',
  total_posts: 'إجمالي المشاركات ',
  total_sources: 'إجمالي المصادر',
  total_authors: 'إجمالي كُتَّاب الرأي',
  created_categories: 'الفئات التي تم إنشاؤها',
  tags: 'الوسوم',
  posts_categories: 'المنشورات /الفئه',
  posts: 'المنشورات',
  source_status: 'حالة المصدر',
  source_status_edition: 'حالة نسخه المصدر',
  top_used_tags: 'الوسوم الأكثر إستخداماً',
  breaking_news: 'أخبار عاجلة',
  top_authors: 'كبار كُتَّاب الرأي',
  top_editors: 'كبار المحررين',
  numOfNewsGrabbed: 'عدد الأخبار التي تم الحصول عليها',
  author_tables: 'جدول كُتَّاب الرأي',
  editor_tables: 'جدول المحررين',
  articles: 'المقالات',
  sources: 'المصادر',
  author: 'كاتب رأي',
  types_of_categories: 'أنواع الفئات',
  related_names: 'الأسماء ذات الصلة',
  source_name: 'اسم المصدر',
  source_url: 'رابط المصدر',
  source_priority: 'أولوية المصدر',
  grab_data_from: 'تاريخ بداية الحصول علي بيانات',
  grab_data_to: 'تاريخ نهاية الحصول علي بيانات',
  graping_start_date: 'تاريخ بداية الحصول علي بيانات',
  regrabbing_period: 'فترة إعادة جلب البيانات',
  grabbing_data_desc:
    'نحن نجمع البيانات. ستشاهد البيانات التي تم جمعها في غضون 5-15 دقيقة. الرجاء الانتظار...',
  grabbing_data_err_desc:
    'نحن غير قادرين على الحصول على الأخبار من عنوان URL المصدر المقدم إما عن طريق الاستيلاء التلقائي',
  html_hint: 'يجب أن يكون لديك معرفة متوسطة HTML للمتابعة',
  start_manual_grabbing: 'ابدأ الجلب اليدوي',
  ch_to_m_grabbing: 'قم بالتحويل للجلب اليدوي',
  ch_to_a_grabbing: 'قم بالتحويل للجلب التلقائي',
  manual_grabbing: 'الجلب اليدوي',
  automatic_grabbing: 'الجلب التلقائي',
  rss: 'rss',
  collect_sections: 'اجمع الأقسام (القائمة)',
  source_page: 'رابط عنوان القسم',
  nearest_attr: 'بحث عن أقرب سمة وفئة لعلامة الارتساء التي تحمل عنوان url',
  pagination_attr: 'بحث عن صفحات الخبر',
  tags: 'الوسوم',
  selectors: 'المحددات',
  grabbed_categories: 'عينة من الفئات المأخوذة',
  grabbed_list: 'عينة من القوائم المأخوذة',
  title: 'العنوان',
  url: 'الرابط',
  news_category: 'فئة الاخبار',
  news_categories: 'فئات الاخبار',
  number_of_posts: 'عدد المنشورات',
  articles_details: 'تفاصيل المقالات',
  find_news_img: 'بحث عن صورة الخبر',
  find_news_title: 'بحث عن عنوان الخبر',
  find_news_editor: 'بحث عن محرر الخبر',
  find_news_details: 'بحث عن تفاصيل الخبر',
  find_news_tags: 'بحث عن علامات الخبر',
  find_news_date: 'بحث عن تاريخ الخبر',

  categories: 'فئات',
  sections_retrieved: 'الاقسام التي تم استردادها',
  assign_category: 'إسناد فئة',
  note: 'ملحوظة من فضلك',
  note_description:
    'أنه إذا لم تقم بتعيين أي فئة ، فسيتم نقلها إلى فئة غير مصنفة',
  grab_to_present: 'جلب البيانات حتي اليوم',
  article_url: 'رابط المقال',
  grabbing_period_hours: 'كل {{time}} ساعات',
  grabbing_period_hour: 'كل {{time}} ساعه',
  every_1_hour: 'كل  ساعة',
  failed_grab: 'فشل في الحصول على البيانات، يرجى التحقق من المحددات',
  collecting_data: 'نحن نجمع البيانات',
  added_media: 'الالبوم المضاف',
  automatic_grabbing_desc:
    'يختار المستخدم الجلب التلقائي وسيحاول النظام تلقائيًا تحديد موقع (الفئات ، الأقسام ، تفاصيل المقالات).',
  rss_desc:
    'يختار المستخدم RSS ، وسيحاول النظام تلقائيًا تحديد موقع تقنية (RSS) في موقع الويب',
  manual_desc:
    'يمكن للمستخدم إضافة مصادر الأخبار من خلال الجلب اليدوي تحديد موقع القائمة عن طريق تحديد (القائمة ، قائمة الأخبار) (الفئة أو العنصر وعلامة الربط الخاصة به) وأخيراً عن طريق تحديد (الفئة أو العنصر وعلامة الربط الخاصة به) للأخبار (الصورة ، اسم المحرر ، التفاصيل ، الوسوم).',

  errorSourceInformation: 'هذا المصدر موجود بالفعل',
  samplesCategories: 'أخبار الصحة، أخبار الاقتصاد، أخبار الوباء',
  direction: 'الإتجاه',
  parent_source: 'المصدر',
  additional_information: 'معلومات إضافية',
  grabbing: 'جلب',
  select_group: 'الرجاء اختيار مجموعة',
  existing_group: 'مجموعة حاليه',
  new_group: 'مجموعة جديدة',
  grabbing_pagination: 'جلب > {{step}} > {{name}}',
  sections: 'الأقسام',
  total_source_editions: 'إجمالي إصدارت المصدر',
  total_editors: 'إجمالي المحررين',
  opinion_articles: 'مقالات الرأى',
  source_edition: ' إصدارت المصدر',
  source_edition_table: 'جدول إصدارت المصدر',
  source_editions_table: 'جدول إصدارت المصدر',

  no_articles: 'عدد المقالات',
  editor_name: 'اسم المحرر',
  no_grabbed_news: 'عدد الأخبار التي تم جلبها',
  location: 'الموقع الجغرافي',
  opinion_articles_grabbed: 'عدد مقالات الرأي التي تم جلبها',
  editors: 'المحررين',
  editor: 'المحرر',
  source_editions_details: 'تفاصيل إصدارت المصدر ',
  total_sources_editions: 'إجمالي إصدارت المصدر',
  source_edition_status: 'حالة إصدارت المصدر',
  skip: 'تخطى',
  you_can_skip: 'يمكنك تخطي الجلب التلقائي',
  variant: 'متغير',
  add_variant: 'إضافة متغير آخر',
  delete_variant: 'حذف متغير',
  are_you_sure_you_want_to_delete_variant:
    'هل انت متأكد أنك تريد حذف متغير حذفا نهائيا ؟',
  editions: 'إصدارت المصدر',
  directions: 'الإتجاهات',
  authors: 'كُتَّاب الرأي',
  key: 'العنوان',
  value: 'النص',
  from: 'من',
  'main section group': 'المجموعة الرئيسية',
  err_title_required: 'الرجاء إدخال محدد عنوان صالح',
  err_source_required: 'يرجي جلب البيانات',
  cancel_edit_author_message:
    'هل أنت متأكد أنك تريد إلغاء تعديل تفاصيل كاتب الرأي',
  cancel_edit_editor_message:
    'هل أنت متأكد أنك تريد إلغاء تعديل تفاصيل المحرر؟',
  date_format: 'صيغة التاريخ',
  choose_date_format: 'اختر تنسيق التاريخ',
  source_editions: ' إصدارات المصدر',
  addauthor: 'إضافة كاتب رأي كمؤثر',
  addnewinfluncerasauthor: ' هل  كاتب الرأي معتمد علي مؤثر ؟ ',
  alreadyexists: ' اضف كاتب الرأي بناءا علي مؤثر موجود',
  newauthorinflncer: 'اضف كاتب الرأي بناءا علي مؤثر جديد',
  authorandinfluncer: 'هذا كاتب رأي و مؤثر',
  selectinf: 'من فضلك اختر المؤثر الموجود',
  searchinf: 'بحث المؤثرين المحللين',
};
